import axios from 'axios';
import HttpAgent, { HttpsAgent } from 'agentkeepalive'

let axiosInstances = {};

export const getHttpInstance = (host) => {

  if (!host) {
    throw new Error('Missing host for http instance');
  }

  if (!axiosInstances[host]) {
    if (process.browser) {
      axiosInstances[host] = axios.create();
    } else {
      const httpAgent = new HttpAgent({ family: 4 });
      const httpsAgent = new HttpsAgent({ family: 4 });

      axiosInstances[host] = axios.create({
        httpAgent,
        httpsAgent
      });
    }
  }

  return axiosInstances[host];
};
